import createLucideIcon from '../createLucideIcon';

const LifeBuoy = createLucideIcon('LifeBuoy', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['circle', { cx: '12', cy: '12', r: '4', key: '4exip2' }],
  ['line', { x1: '4.93', x2: '9.17', y1: '4.93', y2: '9.17', key: '7uid0r' }],
  [
    'line',
    { x1: '14.83', x2: '19.07', y1: '14.83', y2: '19.07', key: '1bs9rn' },
  ],
  ['line', { x1: '14.83', x2: '19.07', y1: '9.17', y2: '4.93', key: '6f5ycr' }],
  ['line', { x1: '14.83', x2: '18.36', y1: '9.17', y2: '5.64', key: '1rsyuq' }],
  ['line', { x1: '4.93', x2: '9.17', y1: '19.07', y2: '14.83', key: '133ud4' }],
]);

export default LifeBuoy;
